import React from 'react';

import { lang } from 'src/helpers';

export const CheckboxField = React.memo(function CheckboxField({
  className = '',
  checked,
  onChange,
  label,
  template,
  disabled,
  style
}) {
  return (
    <div
      className={
        className +
        ' mc-checkbox-field template-' +
        template +
        (checked ? ' checked' : '') +
        (disabled ? ' disabled' : '')
      }
      style={style}
    >
      <label>
        <input
          type='checkbox'
          hidden
          disabled={disabled}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className='checkmark' />
        {typeof label === 'string' ? lang.t(label) : label}
      </label>
    </div>
  );
});

export const CheckboxesField = React.memo(function CheckboxesField({
  list,
  data,
  onChange,
  template = '1',
  disabledList = []
}) {
  return list.map((item, index) => (
    <CheckboxField
      key={'checkbox-' + index}
      label={item.label}
      checked={data.indexOf(item.value) > -1}
      disabled={disabledList.indexOf(item.value) > -1}
      template={template}
      onChange={() => {
        let newData = data.concat([]) || [];
        const index = newData.indexOf(item.value);
        if (index > -1) newData.splice(index, 1);
        else newData.push(item.value);
        onChange(newData);
      }}
    />
  ));
});
